import { dispatch, updateSelectedItemsMap } from '@zonofi/zono-money-store';

export const handleSelectAll = (data: any[]) => {
  if (data && data?.length > 0) dispatch(updateSelectedItemsMap(data));
};
